export const edificios: any[] = [
  { goTo: 'P005', label: 'Sant Hilari Sacalm' },
  { goTo: 'P007', label: 'Granollers' },
  { goTo: 'P008', label: 'Córdoba' },
  { goTo: 'P009', label: 'Córdoba' },
  { goTo: 'P011', label: 'Blanes' },
  { goTo: 'P012', label: 'València' },
  { goTo: 'P013', label: 'Madrid' },
  { goTo: 'P015', label: 'Barcelona' },
  { goTo: 'P016', label: 'Alcoy/Alcoi' },
  { goTo: 'P017', label: 'Vila-real' },
  { goTo: 'P018', label: 'Lena' },
  { goTo: 'P019', label: 'Madrid' },
  { goTo: 'P-010', label: 'Vilanova del Camí' },
  { goTo: '1451', label: 'Zaragoza' },
];

export const rentaAntigua: any[] = [
  { goTo: 'RA_1005', label: 'Santander' },
  { goTo: 'RA_1009', label: 'Santa Coloma de Gramenet' },
  { goTo: 'RA_1010', label: 'Terrassa' },
  { goTo: 'RA10012', label: 'Sant Boi de Llobregat' },
  { goTo: 'RA10012', label: 'Sant Boi de Llobregat' },
  { goTo: 'RA1002', label: 'Getafe' },
  { goTo: 'RA1003', label: 'Madrid' },
  { goTo: 'RA1004', label: 'Llucmajor' },
  { goTo: 'RA1007', label: "L'Hospitalet de Llobregat" },
  { goTo: 'RA1008', label: 'Alcorcón' },
  { goTo: 'RA1011', label: 'San Andrés del Rabanedo' },
  { goTo: 'RA1012', label: 'Ortuella' },
  { goTo: 'RA1013', label: 'Madrid' },
  { goTo: 'RA1014', label: 'Palmas de Gran Canaria, Las' },
  { goTo: 'RA1015', label: 'Cornellà de Llobregat' },
  { goTo: 'RA1016', label: 'Premià de Mar' },
  { goTo: 'RA1017', label: 'Madrid' },
  { goTo: 'RA1019', label: 'Barcelona' },
  { goTo: 'RA1021', label: 'Esparreguera' },
  { goTo: 'RA1022', label: 'Coslada' },
];

export const casasInviertis: any[] = [
  { goTo: '1454', label: 'Nava del Rey' },
  { goTo: '1490', label: 'Vélez-Málaga' },
  { goTo: '1532', label: 'Vinaròs' },
  { goTo: '1546', label: 'Galapagar' },
  { goTo: '1519', label: 'Castellgalí' },
  { goTo: '1536', label: 'Coles' },
  { goTo: '1524', label: 'Matadepera' },
  { goTo: 'ra1012', label: 'Ortuella' },
  { goTo: '1496', label: 'Rota' },
  { goTo: 'ra1018', label: 'Palamós' },
  { goTo: 'an0058', label: 'Cervelló' },
  { goTo: '1131', label: 'Cambrils' },
  { goTo: 'alt0007', label: 'Huércal de Almería' },
  { goTo: '1259', label: 'Chinchón' },
  { goTo: '1199', label: 'Borox' },
  { goTo: 'AN0001', label: 'Lliçà de Vall' },
  { goTo: '1255', label: 'Santervás de la Vega' },
  { goTo: '1253', label: 'Vendrell, El' },
];
